import React, {Component} from 'react';
import styled from "styled-components";

import AppHeader from './app/AppHeader.jsx';
import AppModules from './app/AppModules.jsx';
import AppFiles from './app/AppFiles.jsx';

import AudioProcessor from './audio/AudioProcessor.jsx';
import AudioPlayback from './audio/AudioPlayback.jsx';

const PageWrapper = styled.div`
    font-family: Arial;
    user-select: none;
    overflow: hidden;
`;

export var MAIN_APP = null;
export const PROCESSOR_COUNT = 32;

export class MidiPlay extends Component {

    state = {
        playing: false,
        processors: [],
        profile_data: [],
        events: {},
        error_text: null,
        dropdown: null,
        modal: null,
        playback: null,
        app_files_ref: React.createRef(),
        time_start: 0,
        cursor_pos: 0,
        current_event: {}
    };

    constructor(props) {
        super(props);
        MAIN_APP = this;
    }

    componentDidMount() {
        document.body.style.margin = 0;
        document.body.style.fontFamily = "Arial";
        document.title = "Tone Gallery";

        const ac = new AudioContext();

        const processors = [];
        for (let i = 0; i < PROCESSOR_COUNT; i++) {
            const processor = new AudioProcessor(ac, i);
            processors.push(processor);
        }
        this.setState({
            processors: processors,
        });

        this.initProcessors(ac, processors);

        const playback = new AudioPlayback();
        this.setState({
            playback: playback,
            ac: ac
        });
    }

    initProcessors(ac = this.state.ac, processors = this.state.processors) {

        const compressor_node = ac.createDynamicsCompressor();
        compressor_node.threshold.setValueAtTime(-10, ac.currentTime);
        compressor_node.knee.setValueAtTime(40, ac.currentTime);
        compressor_node.ratio.setValueAtTime(12, ac.currentTime);
        compressor_node.attack.setValueAtTime(0, ac.currentTime);
        compressor_node.release.setValueAtTime(0.25, ac.currentTime);

        const audioMerger = ac.createChannelMerger(PROCESSOR_COUNT);
        const splitter_left = ac.createChannelSplitter(PROCESSOR_COUNT);
        const splitter_right = ac.createChannelSplitter(PROCESSOR_COUNT);
        for (let i = 0; i < PROCESSOR_COUNT; i++) {
            processors[i].out_node_left.connect(splitter_left).connect(audioMerger, i, 0);
            processors[i].out_node_right.connect(splitter_right).connect(audioMerger, i, 1);
        }
        audioMerger
            .connect(compressor_node)
            .connect(ac.destination);
    }

    load_file_events(events, file_meta = {}) {
        console.log('file_meta', file_meta);
        this.setState({
            events: events,
            error_text: null
        });
        this.state.app_files_ref.current.load_file(events, file_meta);
    }

    play() {
        if (!this.state.events) {
            this.setState({error_text: 'Load a midi file to begin'});
            return;
        }
        if (this.state.playing) {
            return;
        }
        if (!this.state.processors) {
            this.setState({error_text: 'Processors are not ready!'});
            return;
        }

        this.setState({
            playing: true
        });

        this.state.playback.start(this.state.events);
    }

    pause() {
        this.setState({playing: false});
        this.state.playback.stop();
        this.initProcessors();
    }

    stop() {
        this.setState({playing: false});
        this.state.playback.stop();
        this.initProcessors();
    }

    render() {
        const dropdown = this.state.dropdown ?? '';
        const modal = this.state.modal ?? '';
        return <PageWrapper>
            {dropdown}
            {modal}
            <AppHeader/>
            <AppModules/>
            <AppFiles ref={this.state.app_files_ref} events={this.state.events} />
        </PageWrapper>
    }
}

export default MidiPlay;
